import useEvent from '@react-hook/event';
export function useKey(target, listeners) {
  useEvent(target, 'keydown', event => {
    const listener = listeners[LEGACY_COMPAT[event.key] || event.key];
    if (listener) listener(event);
  });
} // IE 11 and some versions of Edge have non-standard value

const LEGACY_COMPAT = {
  Up: 'ArrowUp',
  Right: 'ArrowRight',
  Down: 'ArrowDown',
  Left: 'ArrowLeft',
  Esc: 'Escape',
  Spacebar: ' ',
  Del: 'Delete',
  Crsel: 'CrSel',
  Exsel: 'ExSel',
  Add: '+',
  Subtract: '-',
  Multiply: '*',
  Divide: '/',
  Decimal: '.',
  Scroll: 'ScrollLock'
};
export default useKey;